/*
 * @Description: 课程/有声书播放相关 API
 */
import instances from "./public-axios";
const wanosUni = instances["uni"].myRequest;

/**
 * 更新播放进度
 * @param {Object} params - { id, chapterId, progress, type }
 * @param {Number} params.id - 课程/有声书ID
 * @param {Number} params.chapterId - 章节ID
 * @param {Number} params.progress - 播放进度（秒）
 * @param {Number} params.type - 资源类型 (1=有声书, 2=课程)
 */
export function updatePlayStatus(params) {
  return wanosUni.post("/v1/play/chapters/playlog", params);
}

/**
 * 更新播放次数
 * @param {Object} params - { id, chapterId, type }
 * @param {Number} params.id - 课程/有声书ID
 * @param {Number} params.chapterId - 章节ID
 * @param {Number} params.type - 资源类型 (1=有声书, 2=课程)
 */
export function updatePlayCount(params) {
  return wanosUni.post("/v1/play/chapters/playCount", params);
}
